import React from 'react';
import close from "../../../../../../../assets/close.svg";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import { config } from "../../../../../../../config";
import "./UserInfo.css";
export default function UserInfo(props) {

  const data = props.data;
	const closeModal = (reload = false) => {
    (reload === true) ? props.closeModel(reload) : props.closeModel();
	}
  let shirtSize = 'N/A';
    switch (data.shirt_size) {
        case 'S':
            shirtSize = 'Small';
            break;
        case 'M':
            shirtSize = 'Medium';
            break;
        case 'L':
            shirtSize = 'Large';
            break;
        case 'XL':
            shirtSize = 'Extra Large'
            break;
        case 'XXL':
            shirtSize = 'Largest'
            break;
        default :
            break;
    }

  const promoteCaptain = () => {
    axiosApi.post(`${config.apiUrl}/teams/promote/captain`,{
      user_id: data.id,
      team_id: props.teamId
		})
    .then((response) => { 
      closeModal(true);
			});
  }

  const removeFromTeam = () => {
    axiosApi.delete(`${config.apiUrl}/teams/player/${data.id}/${props.teamId}`)
    .then((response) => { 
      closeModal(true);
		});
  }

    return <>
      <div className="modal addAdminModal">
          <div className="modal-header">
              <h2>Player Details</h2>
              <p>Viewing player {data.full_name}</p>
              <span className="close" onClick={closeModal}>
                  <img src={close} alt='close-icon'/>
              </span>
          </div>
          <div className="modal-content">
            <h3>User Info</h3>
            <div className="inner-wrapper">
              <div className="text-blk">
                <span className="label">First Name:</span>
                <span className="value">{data.first_name}</span>
              </div>
              <div className="text-blk">
                <span className="label">Last Name:</span>
                <span className="value">{data.last_name}</span>
              </div>
              <div className="text-blk">
                <span className="label">Email:</span>
                <span className="value">{data.email}</span>
              </div>
              <div className="text-blk">
                <span className="label">Primary Phone:</span>
                <span className="value">{data.cell_phone}</span>
              </div>
              <div className="text-blk">
                <span className="label">Secondary Phone:</span>
                <span className="value">{data.secondary_phone}</span>
              </div>
              <div className="text-blk">
                <span className="label">Shirt Size:</span>
                <span className="value">{shirtSize}</span>
              </div>
              <div className="text-blk">
                <span className="label">Team:</span>
                <span className="value">{props.team}</span>
              </div>
              <div className="text-blk">
                <span className="label">Captain:</span>
                <span className="value">{(props.captainId === data.id)? 'True' : 'False'}</span>
              </div>
              <div className="button-blk">
                <button onClick={() => promoteCaptain()}>Promote to Captain</button>
                <button className="btn-red" onClick={() => removeFromTeam()}>Remove from Team</button>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button onClick={closeModal}>Close</button>
          </div>
      </div>
    </>
}